import { databaseRef } from "api";

const newsRef = databaseRef.child("/news");
const newsPostRef = newsRef.child("/posts");

export async function getNewsPosts() {
  return (await newsPostRef.limitToLast(20).once("value")).val();
}

export async function getLatestPost() {
  let a = (await newsPostRef.orderByChild("time").limitToFirst(1).once("value")).val();
  let objectKey = Object.keys(a)[0]
  return a[objectKey]
}

// export async function getNewsPostDetail(key) {
//   if (key) {
//     const selectedNewsRef = newsPostRef.child(key);
//     return (await selectedNewsRef.once("value")).val();
//   }
//   return null;
// }
